import { gql } from '@apollo/client';

export const EVENT_PLAN_FIELDS = gql`
  fragment EventPlanFields on EventPlan {
    id
    name
    startDate
    startOffset
    endOffset
    location
    groupSize
    events {
      id
      slug
      inquiryStatus
      createdAt
      venueRespondedAt
      planner {
        id
        fullName
        email
      }
      venue {
        id
        name
        slug
        pathname
        logo
      }
      spaces {
        id
        name
        pathname
        slug
        images(limit: 1) {
          url
        }
      }
    }
    guest {
      id
      email
    }
    collaborators {
      id
      fullName
      email
      gravatarUrl
    }
    invitations {
      id
      inviteeEmail
      createdAt
    }
  }
`;

export const UPDATE_EVENT_PLAN = gql`
  mutation UpdateEventPlan($input: UpdateEventPlanInput!) {
    updateEventPlan(input: $input) {
      eventPlan {
        id
        ...EventPlanFields
      }
    }
  }
  ${EVENT_PLAN_FIELDS}
`;

export const SEND_EVENT_PLAN_INVITATION = gql`
  mutation SendEventPlanInvitation($input: SendEventPlanInvitationInput!) {
    sendEventPlanInvitation(input: $input) {
      eventPlanInvitation {
        id
        inviteeEmail
        createdAt
        eventPlan {
          id
          invitations {
            id
            inviteeEmail
            createdAt
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
